import { MouseEventHandler } from 'react'
import { tw } from '../../utils/strings'

export type Props = {
  className?: string
  children?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  value?: string
  onClick?: MouseEventHandler<HTMLLIElement>
  isSelected?: (value: string) => boolean
}

export const Option = ({
  size = 'md',
  value,
  onClick,
  className,
  children,
  isSelected,
}: Props) => {
  const styles = {
    base: tw`flex items-center hover:bg-cool-200 transition-colors duration-200 cursor-pointer min-h-min`,

    sm: tw`text-sm min-h-[theme(spacing.8)] px-3 py-1`,
    md: tw`text-sm min-h-[theme(spacing.10)] px-3 py-1`,
    lg: tw`text-sm min-h-[theme(spacing.12)] px-4 py-2`,
  }

  return (
    <li
      className={`${styles.base} ${styles[size]} ${className}`}
      onClick={onClick}
      data-value={value}
      data-label={children?.toString()}
      role='option'
      aria-selected={isSelected && value ? isSelected(value) : 'false'}
    >
      {children}
    </li>
  )
}
